import { ModelConceptAttribute } from 'src/containers/ProjectDiagram/types/data';

export const createModelConceptAttribute = ({
  value,
  domains = {},
  ranges = {},
}: Partial<ModelConceptAttribute> &
  Pick<ModelConceptAttribute, 'value'>): ModelConceptAttribute => ({
  value,
  domains,
  ranges,
});
